<template>
    <div class="news-page">
        <bread-crumbs />
        <content-subheader-page
            class="news-page-content-subheader"
            :text="newsData.text_header"
        />
        <news-publication-date
            class="news-page-publication-date"
            :date="new Date(newsData.creation_time)"
        />
        <news-holding-date
            v-if="eventDateStart && eventDateEnd"
            class="news-page-holding-date"
            :dateStart="eventDateStart"
            :dateEnd="eventDateEnd"
        />
        <content-text
            class="news-page-content-text"
            :text="newsData.text_main"
        />
        <news-slider
            v-if="newsData.images !== null"
            class="news-page-slider"
            :sliderImg="
                newsData.images ? newsData.images.map((img) => '/' + img) : []
            "
        />
        <NewsVideos
            v-if="newsData.video_links !== null"
            class="news-page-videos"
            :news-videos="newsData.video_links"
        />
        <news-files
            v-if="newsData.files !== null"
            class="news-page-files"
            :files="files"
        />
    </div>
</template>
<script>
import ContentSubheaderPage from '@/components/content/ContentSubheaderPage.vue'
import BreadCrumbs from '@/components/breadcrumbs/BreadCrumbs.vue'
import NewsHoldingDate from '@/components/news/NewsHoldingDate.vue'
import NewsPublicationDate from '@/components/news/NewsPublicationDate.vue'
import ContentText from '@/components/content/ContentText.vue'
import NewsSlider from '@/components/news/NewsSlider.vue'
import NewsFiles from '@/components/news/NewsFiles.vue'
import NewsVideos from '@/components/news/NewsVideos.vue'
import { useRouter } from 'vue-router'
import { useNewsStore } from '@/store/news'

export default {
    name: 'UpcomingEventsPage',
    components: {
        ContentSubheaderPage,
        BreadCrumbs,
        NewsHoldingDate,
        NewsPublicationDate,
        ContentText,
        NewsSlider,
        NewsFiles,
        NewsVideos
    },
    data() {
        return {
            HoldingDate: new Date(2022, 8, 10),
            files: [],
            newsData: {}
        }
    },
    async mounted() {
        const router = useRouter()
        const newsStore = useNewsStore()

        const newsId = Number(router.currentRoute.value.params.id)
        await newsStore.getSingleNews(newsId)
        this.newsData = newsStore.singleNews

        if (this.newsData.files !== null) {
            this.newsData.files
                .map((file) => file.split('||'))
                .forEach((file) => {
                    let arr = file[0].split('/')
                    this.files.push({
                        name: arr[arr.length - 1],
                        href: window.document.location.origin + '/' + file[0]
                    })
                })
        }
        if (newsStore.singleNews.event_id) {
            await newsStore.getNewsEvent(newsStore.singleNews.event_id)
        }

        if (
            this.newsData.video_links !== null &&
            this.newsData.video_links.length > 0
        ) {
            this.newsData.video_links = this.newsData.video_links.map(
                (link) => {
                    if (link.includes('https://vk.com/video')) {
                        const idOidStr = link
                            .substr(link.indexOf('video'))
                            .substring(5, link.indexOf('_'))
                        const idOidArray = idOidStr.split('_')
                        return `https://vk.com/video_ext.php?oid=${idOidArray[0]}&id=${idOidArray[1]}&hd=2`
                    } else if (link.includes('https://rutube.ru/video')) {
                        return link.replace('video', 'play/embed')
                    }

                    return link
                }
            )
        }
    },
    computed: {
        eventDateStart() {
            if (useNewsStore().newsEvent.date_start)
                return new Date(useNewsStore().newsEvent.date_start)
            return null
        },
        eventDateEnd() {
            if (useNewsStore().newsEvent.date_end)
                return new Date(useNewsStore().newsEvent.date_end)
            return null
        }
    }
}
</script>
